import type { ReactElement } from 'react'
import { useDismissedGlobalMessages } from '../../hooks/useDismissedGlobalMessages'
import { useGlobalMessages } from '../../queries/useGlobalMessages'
import { GlobalMessageBanner } from '../GlobalMessageBanner/GlobalMessageBanner'
import { bannersWrapper } from './GlobalMessageBanners.css'

export const GlobalMessageBanners = (): ReactElement | null => {
  const { data: messages } = useGlobalMessages()
  const { isDismissed, dismiss } = useDismissedGlobalMessages()

  const visibleMessages = (messages ?? []).filter(
    (message) => !isDismissed(message)
  )

  if (visibleMessages.length === 0) {
    return null
  }

  return (
    <div className={bannersWrapper}>
      {visibleMessages.map((message) => (
        <GlobalMessageBanner
          key={`${message.id}-${message.updatedAt}`}
          message={message}
          onDismiss={() => dismiss(message)}
        />
      ))}
    </div>
  )
}
